import { Stack, Typography } from "@mui/material";
import { UserPermission } from "commons/enum/permission";
import { observer } from "mobx-react-lite";
import { useCallback } from "react";
import { AddButton } from "share-components/mui-wrap/button/action-button";
import { SearchButton } from "share-components/mui-wrap/button/search-button";
import { useStores } from "../../../mobx-stores/_root-store";
import { XSearchTextField } from "../../../share-components/mui-wrap/text-field/x-search-text-field";
import { PageContainer } from "../../../share-components/templates/page/page-container";
import { PageContentContainer } from "../../../share-components/templates/page/page-content-container";
import { PageFilterContainer } from "../../../share-components/templates/page/page-filter-container";
import { PageHeaderContainer } from "../../../share-components/templates/page/page-header-container";
import { AddUser } from "./add-user/add-user";
import { EditUser } from "./edit-user/edit-user";
import { UserList } from "./user-list/user-list";

export const User = observer(() => {
  const {
    userManagement: { openNew, openEdit, getUsers, pagination },
  } = useStores();
  const onSearch = useCallback(async () => {
    pagination.setProp("pageIndex", 0);
    await getUsers({
      filter: pagination.filter,
      maxResultCount: pagination.itemsPerPage,
      skipCount: pagination.skipCount,
      sorting: "",
    });
  }, [getUsers, pagination]);
  return (
    <PageContainer>
      <PageHeaderContainer direction={"row"} justifyContent={"space-between"}>
        <Header></Header>
      </PageHeaderContainer>
      <PageFilterContainer direction={"row"}>
        <Stack
          direction={"row"}
          alignItems={"center"}
          spacing={1}
          flexWrap={"wrap"}
          rowGap={"10px"}
        >
          <XSearchTextField
            sx={{
              minWidth: "300px",
            }}
            value={pagination.filter}
            onChange={(e) =>
              pagination.setProp("filter", e.currentTarget.value)
            }
          ></XSearchTextField>

          <SearchButton asyncAction={onSearch}></SearchButton>
        </Stack>
      </PageFilterContainer>
      <PageContentContainer>
        <UserList></UserList>
      </PageContentContainer>

      <>
        {openNew && <AddUser></AddUser>}
        {openEdit && <EditUser />}
      </>
    </PageContainer>
  );
});

const Header = observer(() => {
  const {
    userManagement: { setProp },
  } = useStores();
  return (
    <>
      <Stack>
        <Typography variant="subtitle2">Người dùng</Typography>
      </Stack>
      <Stack>
        <AddButton
          accessPermission={[UserPermission.Create]}
          onClick={() => setProp("openNew", true)}
        >
          Thêm mới
        </AddButton>
      </Stack>
    </>
  );
});
